import { cx } from "../cx";

/** A row of bouncing cyan bars. Decoration only: hidden from assistive tech, still under reduced motion. */
export function Visualizer({ bars = 14, class: cls }: { bars?: number; class?: string }) {
  return (
    <div class={cx("viz", cls)} aria-hidden="true">
      {Array.from({ length: bars }, (_, i) => (
        <i key={i} />
      ))}
    </div>
  );
}
